<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        cập nhật thông tin kiểm hàng
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="() => (dialog = false)">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-6">
        <v-form ref="form">
          <UpdateInfoMany
            ref="updateMany"
            v-if="type === 'many'"
            @refresh="
              () => {
                refresh()
                this.dialog = false
              }
            "
          />
          <UpdateInfo
            ref="updateOnly"
            v-if="type === 'only' && dialog"
            @change="onChange"
            @refresh="
              () => {
                refresh()
                this.dialog = false
              }
            "
            :auditProduct="item"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$auth.policies['import-checks:update-product']"
          @click="onSaveUpdate"
          class="ma-2"
          dark
          depressed
          color="#0D47A1"
          ><v-icon>check</v-icon>Xác nhận thông tin</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UpdateInfoMany from '../../modules/detail-audit-product/UpdateInfoMany.vue'
import UpdateInfo from '../../modules/detail-audit-product/UpdateInfo.vue'
import { mapActions } from 'vuex'
export default {
  name: 'AddProductButton',
  components: { UpdateInfo, UpdateInfoMany },
  data() {
    return {
      item: null,
      items: null,
      type: '',
      dialog: false,
      info: {
        productModels: null
      },
      listAreas: {}
    }
  },
  methods: {
    ...mapActions({
      addModelToBill: 'importOrders/addModel',
      removeModel: 'importOrders/removeModel',
      updateItem: 'importDeliveryProduct/updateItem',
      updateManyItems: 'importDeliveryProduct/updateManyItems'
    }),
    onChange(val) {
      this.listAreas[`${val.saleArea}`] = val
    },
    openDialog(type, data) {
      if (type === 'only') this.item = data
      if (type === 'many') this.items = data
      this.type = type
      this.dialog = true
    },
    refresh() {
      this.item = null
      this.items = null
      this.$emit('refresh')
    },
    async onSaveUpdate() {
      if (!this.$auth.policies['import-checks:update-product']) return
      const isFormValid = await this.$refs.form.validate()
      if (isFormValid) {
        if (this.type === 'only') await this.$refs['updateOnly'].onSave()
        if (this.type === 'many') {
          const listModel = this.items.map(v => v._id)
          if (!listModel.length) return this.$alert.error('Vui lòng chọn sản phẩm')
          this.$refs['updateMany'].onSave(listModel)
        }
      }
    }
  }
}
</script>
